var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgListPlusIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#listPlusIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 7.5h-6c-.83 0-1.5-.67-1.5-1.5V0L21 7.5Zm-10.5 3.75c0-.412.338-.75.75-.75h1.5c.412 0 .75.338.75.75v2.25h2.25c.413 0 .75.338.75.75v1.5c0 .413-.337.75-.75.75H13.5v2.25c0 .413-.338.75-.75.75h-1.5a.752.752 0 0 1-.75-.75V16.5H8.25a.752.752 0 0 1-.75-.75v-1.5c0-.412.338-.75.75-.75h2.25v-2.25Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 3c0-1.655 1.345-3 3-3h7.5v6c0 .83.67 1.5 1.5 1.5h6V21c0 1.655-1.345 3-3 3H6c-1.655 0-3-1.345-3-3V3Zm7.5 8.25v2.25H8.25a.752.752 0 0 0-.75.75v1.5c0 .413.338.75.75.75h2.25v2.25c0 .413.338.75.75.75h1.5c.412 0 .75-.337.75-.75V16.5h2.25c.413 0 .75-.337.75-.75v-1.5a.752.752 0 0 0-.75-.75H13.5v-2.25a.752.752 0 0 0-.75-.75h-1.5a.752.752 0 0 0-.75.75Z",
  opacity: 0.4
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "listPlusIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3 0h18v24H3z"
})))));
export default SvgListPlusIcon;